export const clients = [
  {
    value: 'web',
    label: 'Web',
    url: 'https://v2.app.sloyd.ai',
  },
  {
    value: 'admin',
    label: 'Admin',
    url: 'https://admin.sloyd.ai',
  },
  {
    value: 'platform',
    label: 'Platform',
    url: 'https://platform.sloyd.ai',
  },
];
